import React from 'react';
import PropTypes from 'prop-types';

import './credit-card-image.less';

const CreditCardImage = ({ src, alt, className }) => (
  <div className={`image-element-wrapper ${className || ''}`}>
    <img className="image-element-image" src={src} alt={alt} />
  </div>
);

CreditCardImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  className: PropTypes.string,
};

CreditCardImage.displayName = 'CreditCardImage';

export default CreditCardImage;
